var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"auth":_vm.auth,"authenticated":_vm.authenticated}})
}
var staticRenderFns = []

export { render, staticRenderFns }